import React, { useState, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Button from '../button';
import './index.scss';

const SnackBar = ({
  message,
  primaryAction,
  primaryLabel,
  secondaryAction,
  secondaryLabel,
  className,
  autoHideDuration,
  open,
  onClose,
  borderColor,
  ...rest
}) => {
  const componentRef = useRef();
  const [snackbarOpen, setSnackbarOpen] = useState(open);

  useEffect(() => {
    setSnackbarOpen(open);
    let timeout;

    if (open) {
      timeout = setTimeout(handleClose, autoHideDuration);
    }

    return () => {
      clearTimeout(timeout);
    };
  }, [open]);

  function handleClick({ target }) {
    if (componentRef.current.contains(target)) return;
    handleClose();
  }

  function handleClose() {
    setSnackbarOpen(false);
    onClose();
  }

  useEffect(() => {
    document.addEventListener('mousedown', handleClick);
    return () => document.removeEventListener('mousedown', handleClick);
  }, []);

  return (
    <div
      ref={componentRef}
      className={classNames('rc-snackbar', className, {
        open: snackbarOpen,
        'has-two-buttons': primaryLabel && secondaryLabel,
      })}
      {...rest}
    >
      <div style={{ borderColor }}>
        <p>{message}</p>
        {(primaryLabel || secondaryLabel) && (
          <div className="rc-snackbar-buttons">
            {primaryLabel && (
              <Button onClick={primaryAction}>{primaryLabel}</Button>
            )}
            {secondaryLabel && (
              <Button onClick={secondaryAction}>{secondaryLabel}</Button>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

SnackBar.propTypes = {
  message: PropTypes.string.isRequired,
  primaryAction: PropTypes.func,
  primaryLabel: PropTypes.string,
  secondaryAction: PropTypes.func,
  secondaryLabel: PropTypes.string,
  open: PropTypes.bool,
  className: PropTypes.string,
  autoHideDuration: PropTypes.number,
  onClose: PropTypes.func,
  borderColor: PropTypes.string,
};

SnackBar.defaultProps = {
  primaryAction: () => {},
  secondaryAction: () => {},
  onClose: () => {},
  open: false,
  autoHideDuration: 10000,
  borderColor: 'transparent',
};

export default SnackBar;
